<script setup>
import {onMounted, ref, inject} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import {getLogo} from "@/helpers/logo";

const need = inject('need');
const startups = ref([]);

onMounted(() => {
    getStartups();
});

async function getStartups() {
    const {data} = await needsService.getSuggestedStartups(need.value.id);
    startups.value = data;
}
</script>

<template>
    <div class="dashboard-page__card need-admin__card--double">
        <div class="dashboard-page__card__inner">
            <h3 class="dashboard-page__title dashboard-page__title--ai">Suggested Startups</h3>

            <div class="dashboard-page__table dashboard-page__table-flexible">
                <table>
                    <tbody>
                    <tr v-for="startup in startups" :key="startup.id">
                        <td class="pl-0">
                            <div class="dashboard-page__table__title">
                                <div class="data-labels-set data-labels-set--lg">
                                    <span class="data-label data-label--lightning">
                                        <img :src="getLogo(startup.logo)"/>
                                    </span>
                                </div>
                                <div>
                                    <h6 class="heading6"><a :href="`/startups/${startup.id}`" target="_blank">{{ startup.name }}</a></h6>
                                    <p>{{startup.score}}% match</p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="status-plate-wrapper">
                                <span class="status-plate status-plate--unreviewed">Smart Packaging</span>
                                <span class="status-plate status-plate--unreviewed">Artificial Intelligence</span>
                            </div>
                        </td>
                        <td align="right" class="pr-0">
                            <button v-if="startup.submitted" disabled class="button button--lg button-secondary">
                                Startup Submitted
                            </button>

                            <button v-else class="button button--lg button-primary">
                                Submit Startup
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
